var map = {
	"./surfair-dark.png": 777,
	"./surfair.png": 778
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 776;


//////////////////
// WEBPACK FOOTER
// ./src/components/AirlineLogo/images/logos ^\.\/surfair.*\.png$
// module id = 776
// module chunks = 0